function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  const expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
    
function getCookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
  
function delCookie(name) {
  setCookie(name, "", null , null , null, 1);
}

const login = document.getElementById('CustomerLoginForm');
const recover = document.getElementById('RecoverPasswordForm');
  
function onHashChange() {
if (!recover || !login) return;

if (window.location.hash === '#recover') {
    login.style.opacity = 0;
    login.style.pointerEvents = 'none';
    recover.style.opacity = 1;
    recover.style.pointerEvents = 'auto';
  } else {
    login.style.opacity = 1;
    login.style.pointerEvents = 'auto';
    recover.style.opacity = 0;
    recover.style.pointerEvents = 'none';

    if (getCookie('recover')) {
      delCookie('recover');
      const messages = document.querySelectorAll('.js-recover-password-success');
      for (const message of messages) {
        message.removeAttribute('hidden');
      }
    }
  }
}
  
onHashChange();

window.addEventListener('hashchange', onHashChange, false);
  
document.getElementById('HideRecoverPasswordLink').addEventListener('click', function() {
  window.location.hash = '';
});

recover.querySelector('form').addEventListener('submit', function(evt) {
  setCookie('recover', 'true', 1);
});
